import { Loader2 } from 'lucide-react';
import { useAdminConversations } from '../hooks/useAdminConversations';
import { ConversationRow } from './ConversationRow';

interface ConversationListProps {
  currentConversationId: string;
  onSelect: (conversationPublicId: string) => void;
}

/** Past conversations with the assistant, most recent first. */
export const ConversationList: React.FC<ConversationListProps> = ({
  currentConversationId,
  onSelect,
}) => {
  const { data, isLoading, error } = useAdminConversations(true);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-6 text-slate-500 dark:text-slate-400">
        <Loader2 size={18} className="animate-spin" />
      </div>
    );
  }
  if (error) {
    return (
      <p className="p-4 text-sm text-red-600 dark:text-red-400">Could not load conversations.</p>
    );
  }
  if (!data?.length) {
    return <p className="p-4 text-sm text-slate-500 dark:text-slate-400">No conversations yet.</p>;
  }

  return (
    <ul className="divide-y divide-slate-100 dark:divide-slate-700">
      {data.map((conversation) => (
        <li key={conversation.conversationPublicId}>
          <ConversationRow
            conversation={conversation}
            isCurrent={conversation.conversationPublicId === currentConversationId}
            onSelect={onSelect}
          />
        </li>
      ))}
    </ul>
  );
};
